import { render } from "./UserWrapper.vue?vue&type=template&id=1934c3ab&ts=true"
import script from "./UserWrapper.vue?vue&type=script&lang=ts"
export * from "./UserWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/sora/Documents/ss/kochi_bus_admin_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__